/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';

import actionComponents from '@src/oms/FulfillmentView/action-components/index';
import { ItemsOrderViewSection } from '@broadleaf/admin-components/dist/oms/components';
import FulfillmentCardHeader from '@src/oms/ItemsOrderViewSection/components/FulfillmentCard/components/FulfillmentCardHeader/index';
import FulfillmentCardContainer from '@src/oms/ItemsOrderViewSection/components/FulfillmentCard/components/FulfillmentCardContainer/index';
import FulfillmentCardBody, {
  FulfillmentCardActions,
  FulfillmentCardItem,
  FulfillmentCardItems
} from '@src/oms/ItemsOrderViewSection/components/FulfillmentCard/components/FulfillmentCardBody/index';
import FulfillmentCard from '@src/oms/ItemsOrderViewSection/components/FulfillmentCard/index';
import { FulfillmentCards } from '@src/oms/ItemsOrderViewSection/components/index';

const overrideComponents = {
  FulfillmentCards,
  FulfillmentCard,
  FulfillmentCardContainer,
  FulfillmentCardBody,
  FulfillmentCardItems,
  FulfillmentCardItem,
  FulfillmentCardActions
};

export const RmItemsOrderViewSection = props => {
  return <ItemsOrderViewSection {...props} components={overrideComponents} />;
};

RmItemsOrderViewSection.TYPE = ItemsOrderViewSection.TYPE;
RmItemsOrderViewSection.actionComponents = actionComponents;
RmItemsOrderViewSection.namedComponentOverrides = [
  { type: 'blFulfillmentCardHeader', component: FulfillmentCardHeader }
];
export default RmItemsOrderViewSection;
